import { elem, typeArray } from './elements.js';
import * as Common from './common.js';



const validClass = 'valid',
      errorClass = 'error';



/**
*** エラーを表示する
*** @param {*} element object
*** @param {*} name object
*** @param {*} message object
*** @param {*} valid object
*** @returns boolean
**/
export function showError( target, arg )
{
  const el = Common.isNodeList(target) ? target[0] : target;

  // 引数をループさせる
  for (const [key, value] of Object.entries(arg)) {

    // エラーメッセージを表示する要素
    const errorElement = document.getElementById(key + '_error');

    // value は配列なのでループさせる
    for( const elem of value ){

      const name    = elem.name,
            message = elem.message,
            valid   = elem.valid;


      // その要素の valid が false でメッセージを表示
      if( name === el.name && valid === false ){
        errorElement.innerHTML = Common.errorMessage(message);
        errorElement.classList.add(validClass);

        // input 要素のものはエラー用の .error クラスを付ける
        if( typeArray[0].includes( Common.getType(el) ) || Common.getType(el) === 'select-one' ){
          el.classList.add(errorClass);
        }
        break;

      }
      else if( valid === false ) {
        errorElement.innerHTML = Common.errorMessage(message);
        errorElement.classList.add(validClass);

        if( typeArray[0].includes( Common.getType(el) ) || Common.getType(el) === 'select-one' ){
          el.classList.remove(errorClass);
          vivaForm[name].classList.add(errorClass);
        }
        break;

      }
      else {
        // メッセージを消す
        errorElement.innerHTML = '';
        errorElement.classList.remove(validClass);
        if( typeArray[0].includes( Common.getType(el) ) || Common.getType(el) === 'select-one' ){
          el.classList.remove(errorClass);
          // グループに属している要素の場合は自身以外もクラスを削除する
          if( Common.getGroupProp(Validations.group, name) ){
            value.forEach( val => {
              if( val.valid === true ){
                vivaForm[name].classList.remove(errorClass);
              }
            });
          }
        }
      }
    };

  }

}



/**
*** エラーを消去する
*** @param {*} elements object
*** @return
**/
export function erasureError( elements )
{
  const formElements = elements;

  // すべてのエラー表示を消去する
  const errors = vivaForm.querySelectorAll('[id$="_error"]');
  for( const error of errors ){
    error.innerHTML = '';
  }

  // 要素の .error クラスを除去する
  for( const element of formElements ){
    const el = Common.isNodeList(element) ? element[0] : element;
    if( typeArray[0].includes( Common.getType(el) ) || Common.getType(el) === 'select-one' ){
      el.classList.remove(errorClass);
    }
  }
}
